import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 686.84 200",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 654.68,
			width: 32.16,
			height: 200,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			points: "493.94 0 621.12 200 654.6 200 527.42 0 493.94 0",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 461.7,
			width: 32.16,
			height: 200,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m386.11,0h-157.85v200h32.17v-82.15h125.69c32.54,0,58.93-26.38,58.93-58.93S418.65,0,386.11,0Zm22.62,92.52h-148.31V25.33h148.31v67.19Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m152.68,0H0v199.99h152.68c31.11,0,56.33-25.22,56.33-56.33,0-17.61-8.09-33.34-20.76-43.67,12.66-10.33,20.76-26.05,20.76-43.67,0-31.11-25.22-56.33-56.33-56.33ZM32.17,25.33h140.54v62H32.17V25.33Zm140.54,149.33H32.17v-61.99h140.54v61.99Z",
			fill: "white"
		})
	]
});
export default SvgLogoIcon;
